import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import {connect} from 'react-redux';
import logoBrandLarge from '../../assets/logo_brand_large.png';
import './BottomMenuBar.css';

class BottomMenuBar extends Component {
  render() {
    return (
      <div className="Center-Text Custom-BottomMenuBar-Margins ui borderless bottom fluid vertical menu">
        <div className="ui item">
          <Link className="Bottom-menu-text" to="/terms">Terms & Conditions</Link>
          &nbsp;&nbsp;|&nbsp;&nbsp;
          <Link className="Bottom-menu-text" to="/privacy">Privacy Policy</Link>
          &nbsp;&nbsp;|&nbsp;&nbsp;
          <Link className="Bottom-menu-text" to="/contact">Contact Us</Link>
        </div>
        <div className="ui item">
          <Link to="/">
            <img className="logo" src={logoBrandLarge} alt="logo" id="bottom-logo"/>
          </Link>
        </div>
        <div className="ui item">
          <p className="Bottom-menu-text">© 2018 Permutize</p>
        </div>
      </div>
    );
  }
}

export default connect(
  (state) => ({}),
  {}
)(BottomMenuBar)


// WEBPACK FOOTER //
// ./src/components/BottomMenuBar/BottomMenuBar.js